import FIKA from "assets/images/icons/fika-icon.svg";
import TRENT from "assets/images/icons/trent-icon.svg";
import GENERICO from "assets/images/icons/generico-icon.svg";
import SINASIGNAR from "assets/images/icons/sinAsignar-icon.svg";
import FEMMTO from "assets/images/icons/femmto-icon.svg";
import MeliIcon from "assets/images/icons/meli-icon.svg";
import VtexIcon from "assets/images/icons/vtex-icon.svg";
import AmazonIcon from "assets/images/icons/amazon-icon.svg";
import B2bIcon from "assets/images/icons/b2b-icon.svg";
import styled from "@emotion/styled";
import { Switch } from "@mui/material";

export const COLUMNS_TO_FILTER = [
  { data: "thumbnail", label: "Foto" },
  { data: "sku", label: "SKU" },
  { data: "buybox", label: "Buy Box" },
  // { data: 'channel', label: 'Canal' },
  { data: "status", label: "Estado" },
  { data: "listingtypename", label: "Tipo de publicación" },
  {
    data: "usdcost",
    label: "LC USD (Actual)",
  },
  {
    data: "localcost",
    label: "LC Local (Actual)",
  },
  {
    data: "pvp",
    label: "PVP (Actual)",
  },
  {
    data: "pvpdisbyte",
    label: "PVP Disbyte (Actual)",
  },
  { data: "pvpbuyer", label: "Precio (Actual)" },
  {
    data: "discount",
    label: "Descuento (Actual)",
  },
  {
    data: "margen",
    label: "Margen % (Actual)",
  },
  { data: "roi", label: "ROI (Actual)" },
  { data: "freeshipping", label: "Free Shipping" },
  {
    data: "usdcost_proyectado",
    label: "LC USD (Proyectado)",
  },
  {
    data: "localcost_proyectado",
    label: "LC Local (Proyectado)",
  },
  {
    data: "pvp_proyectado",
    label: "PVP (Proyectado)",
  },
  {
    data: "pvpdisbyte_proyectado",
    label: "PVP Disbyte (Proyectado)",
  },
  { data: "pvpbuyer_proyectado", label: "Precio (Proyectado)" },
  {
    data: "discount_proyectado",
    label: "Descuento (Proyectado)",
  },
  {
    data: "margen_proyectado",
    label: "Margen % (Proyectado)",
  },
  { data: "roi_proyectado", label: "ROI (Proyectado)" },
  { data: "freeshipping_proyectado", label: "Free Shipping (Proyectado)" },
];

export const INITIAL_COLUMNS_STATE = {
  // channel: true,
  thumbnail: true,
  sku: true,
  buybox: true,
  status: true,
  listingtypename: true,
  usdcost: true,
  localcost: true,
  pvp: true,
  pvpdisbyte: true,
  pvpbuyer: true,
  discount: true,
  discount_proyectado: true,
  margen: true,
  margen_proyectado: true,
  roi: true,
  freeshipping: true,
  usdcost_proyectado: true,
  localcost_proyectado: true,
  pvp_proyectado: true,
  pvpdisbyte_proyectado: true,
  pvpbuyer_proyectado: true,
  roi_proyectado: true,
  freeshipping_proyectado: true,
};

export const INITIAL_LISTINGTYPENAMES_STATE = [
  { data: "Todas", label: "Todas" },
  { data: "Clásica", label: "Clásica" },
  { data: "Premium", label: "Premium" },
];
export const INITIAL_CHANNELS_STATE = { data: ["MELI", "VTEX"] };

export const brandIcons = {
  FIKA: FIKA,
  TRENT: TRENT,
  GENERICO: GENERICO,
  "SIN ASIGNAR": SINASIGNAR,
  FEMMTO: FEMMTO,
};

export const MarketplaceIcons = {
  MELI: MeliIcon,
  VTEX: VtexIcon,
  AMZN: AmazonIcon,
  OFF: B2bIcon,
};

export const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase": {
    "&.Mui-checked": {
      color: "#354887", // color del switch cuando está encendido
      "& + .MuiSwitch-track": {
        backgroundColor: "#9aa3c3", // color del cuerpo cuando está encendido
      },
    },
  },
}));
